import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useAppSelector } from "../../store";

import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { renderTemplate } from "../../utils/http/templates";
import { transformPathToUrl } from "../../utils/url";

function AutomationActionsBottom() {
  const navigate = useNavigate();

  const selectedPath = useAppSelector((state) => state.templates.selectedPath);
  const selectedVersion = useAppSelector((state) => state.templates.selectedVersion);

  const selectedTemplateSummary = useAppSelector((state) => state.templates.selectedTemplateSummary);
  const [versionsForSelectedPath, setVersionsPerSelectedPath] = useState<string[]>([]);

  const [pureHtmlCopied, setPureHtmlCopied] = useState(false);

  useEffect(() => {
    setVersionsPerSelectedPath(selectedTemplateSummary?.versions || []);
  }, [selectedTemplateSummary]);

  const { mutate: mutateCopyPureHtml } = useMutation({
    mutationFn: async () => {
      // get the signal from React Query’s context
      const controller = new AbortController();
      const { signal } = controller;

      return await renderTemplate({ signal, key: selectedPath!, version: selectedVersion, showPureHtml: true });
    },
    onSuccess: async (data) => {
      navigator.clipboard.writeText(data.rendered_content || "");
      setPureHtmlCopied(true);

      setTimeout(async () => {
        setPureHtmlCopied(false);
      }, 2000);
    },
  });

  if (!selectedPath || !selectedTemplateSummary) {
    return <div></div>;
  }

  return (
    <Container className="my-4">
      <Row>
        <Col xs={6}>
          {versionsForSelectedPath.length > 0 && (
            <Form.Group as={Col} className="p-0 pe-1">
              <Form.Select
                value={selectedVersion}
                onChange={(e) => {
                  navigate(transformPathToUrl({ path: selectedPath, version: e.target.value }));
                }}
                style={{ backgroundColor: "#e4e6f5" }}
              >
                {versionsForSelectedPath
                  // .filter((v) => v in ["draft", "live"])
                  .map((version) => (
                    <option key={version} value={version}>
                      {version.charAt(0).toUpperCase() + version.slice(1)}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
          )}
        </Col>
        <Col xs={3}></Col>
        <Col>
          <Container className="p-0">
            <Row>
              <Form.Group as={Col} className="p-0 ps-1 pe-1">
                <Button
                  onClick={() => mutateCopyPureHtml()}
                  style={{
                    width: "100%",
                    backgroundColor: "#e4e6f5",
                    border: "none",
                    color: "#212529",
                  }}
                >
                  {!pureHtmlCopied && <span>Copy HTML</span>}
                  {pureHtmlCopied && (
                    <span>
                      Copied! <i className="bi bi-check-circle-fill" style={{ color: "#28a745" }}></i>
                    </span>
                  )}
                </Button>
              </Form.Group>
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}

export default AutomationActionsBottom;
